import apiClient from "./client";

/**
 * Authentication API Service
 */
export const authApi = {
  /**
   * Login with email and password
   */
  login: (email, password) => {
    return apiClient.post("/auth/login", { email, password });
  },

  /**
   * Refresh access token
   */
  refresh: (refreshToken) => {
    return apiClient.post("/auth/refresh", { refreshToken });
  },

  /**
   * Logout current user
   */
  logout: () => {
    return apiClient.post("/auth/logout");
  },

  /**
   * Get current user profile
   */
  getCurrentUser: () => {
    return apiClient.get("/auth/me");
  },

  /**
   * Change password (when logged in)
   */
  changePassword: (currentPassword, newPassword) => {
    return apiClient.post("/auth/change-password", {
      currentPassword,
      newPassword,
    });
  },

  /**
   * Request password reset email
   */
  forgotPassword: (email) => {
    return apiClient.post("/auth/forgot-password", { email });
  },

  /**
   * Validate password reset token
   */
  validateResetToken: (token, email) => {
    return apiClient.get("/auth/validate-reset-token", { token, email });
  },

  /**
   * Reset password using token
   */
  resetPassword: (token, email, newPassword) => {
    return apiClient.post("/auth/reset-password", {
      token,
      email,
      newPassword,
    });
  },
};

export default authApi;
